import { Avatar } from "@mantine/core";
import type { MantineSize } from "@mantine/core/lib/core";
import { IconDog } from "@tabler/icons-react";
import { config } from "@/config";

interface OwnerProfile {
  name?: undefined;
  firstName: string;
  lastName: string;
  portraitFullPath?: string | null;
}

interface DogProfile {
  firstName?: undefined;
  lastName?: undefined;
  name: string;
  portraitFullPath?: string | null;
}

export const Portrait = ({
  profile,
  size,
  who,
  onClick,
  withBorder = false,
}: {
  profile: OwnerProfile | DogProfile;
  size: MantineSize | string;
  who?: "person" | "dog";
  withBorder?: boolean;
  onClick?: () => void;
}) => {
  const portrait =
    profile.portraitFullPath &&
    `${config.cloudfrontRoot}/${profile.portraitFullPath}`;

  const name = profile.name
    ? profile.name
    : `${profile.firstName} ${profile.lastName}`;
  const icon = who === "dog" ? <IconDog size={"50%"} /> : undefined;
  const style = withBorder ? { border: "4px solid white" } : {};
  return (
    <Avatar
      name={name}
      src={portrait}
      size={size}
      color="initials"
      style={style}
      onClick={onClick}
    >
      {icon}
    </Avatar>
  );
};
